import PositionedOverlay from './PositionedOverlay';

export { Props, PreferredPosition, OverlayDetails, PreferredAlignment } from './PositionedOverlay';
export default PositionedOverlay;
